import React from "react";
import styles from "./Tenders.module.css";

const careerOpenings = [

  {
    title: "General Manager (Hospitality & Estate)",
    supportingDocs: [
      { label: "Notification", url: "/pdfs/careers/Hiring_Notification.pdf" },
    ],
    applyLink: "https://forms.gle/JqvbbHc6fCsCw5vz6",
  },
];

const normalizeDocs = (docs = []) => {
  if (typeof docs === "string") {
    return docs
      .split("||")
      .filter((doc) => doc.trim() !== "")
      .map((url, index) => ({
        label: `Doc ${index + 1}`,
        url,
      }));
  }

  return docs.filter((doc) => doc?.url);
};

const Careers = () => {
  return (
    <div className="container-fluid px-0">
      <div className={styles.bannerContainer}>
        <img
          src="/images/unsplash2.jpg"
          alt="Careers Banner"
          className={`img-fluid w-100 ${styles.bannerImage}`}
        />
        <div
          className={`position-absolute top-50 start-50 translate-middle text-white text-center ${styles.bannerText}`}
        >
          <h2 className="fw-bold text-white">Careers</h2>
        </div>
      </div>

      <div className="container-fluid py-4 px-3">
        {careerOpenings.length === 0 ? (
          <p className="text-center">No active career opportunities available.</p>
        ) : (
          <>
            <div className="d-none d-md-block">
              <div className={`table-responsive ${styles.tableContainer}`}>
                <table
                  className={`table table-bordered align-middle text-center ${styles.table}`}
                >
                  <thead className={styles.tableHead}>
                    <tr>
                      <th className={styles.th}>SL</th>
                      <th className={`${styles.th} ${styles.thTitle}`}>
                        Job Title
                      </th>
                      <th className={styles.thDocuments}>
                        Supporting Documents
                      </th>
                      <th className={styles.th}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {careerOpenings.map((career, index) => {
                      const docs = normalizeDocs(career.supportingDocs);

                      return (
                        <tr key={career.title || index} className={styles.tableRow}>
                          <td className={styles.td}>{index + 1}</td>
                          <td className={styles.tdTitle}>{career.title}</td>
                          <td className={styles.td}>
                            {docs.length > 0 ? (
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2, 1fr)",
                                  gap: "5px",
                                }}
                              >
                                {docs.map((doc, docIndex) => (
                                  <a
                                    key={`${doc.url}-${docIndex}`}
                                    href={doc.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`btn btn-sm btn-outline-primary w-100 ${styles.btnSm}`}
                                  >
                                    {doc.label || `Doc ${docIndex + 1}`}
                                  </a>
                                ))}
                              </div>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className={styles.td}>
                            {career.applyLink ? (
                              <a
                                href={career.applyLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`btn btn-sm btn-success ${styles.btnSm}`}
                              >
                                Apply Now
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="d-md-none">
              {careerOpenings.map((career, index) => {
                const docs = normalizeDocs(career.supportingDocs);

                return (
                  <div className="card mb-3" key={career.title || index}>
                    <div className="card-body">
                      <h5 className="card-title">
                        <span className="badge bg-secondary me-2">
                          {index + 1}
                        </span>
                        {career.title}
                      </h5>
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {docs.map((doc, docIndex) => (
                          <a
                            key={`${doc.url}-${docIndex}`}
                            href={doc.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`btn btn-sm btn-outline-primary ${styles.btnSm}`}
                          >
                            {doc.label || `Doc ${docIndex + 1}`}
                          </a>
                        ))}
                        {career.applyLink && (
                          <a
                            href={career.applyLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`btn btn-sm btn-success ${styles.btnSm}`}
                          >
                            Apply Now
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Careers;
